import { Settings } from '@xeetr/types/models'
import { AxiosResponse } from 'axios'

export const parseSettings = (req: AxiosResponse): Settings => {
  const { user, tenant }: Settings = req.data

  const mappedTenant = {
    ...tenant,
    settings: {
      ...tenant.settings,
    },
    shifts: tenant.shifts.map((service) => ({
      ...service,
      from: new Date(service.from),
      until: new Date(service.until),
      settings: {
        ...service.settings,
        deadlineOnlineReservation:
          service.settings.deadlineOnlineReservation &&
          new Date(service.settings.deadlineOnlineReservation),
      },
    })),
  }
  return {
    user,
    tenant: mappedTenant,
  }
}
